export class UserSplendid {
    constructor(
        public id:string = '',
        public full_name :string = '',
        public user_name:string = '',
        public picture:string = '',
        public role:string = ''
    ) {}

    static fromJson(json:any) {
        return new UserSplendid(
            json.ID,
            json.FULL_NAME,
            json.USER_NAME,
            json.PICTURE,
            json.PRIMARY_ROLE_NAME
        );
    }

}


// WEBPACK FOOTER //
// /app/src/app/models/UsersSplendid.ts